import React from "react";
import { Element } from "react-scroll";
import "./Success_Partners.css";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  EffectCoverflow,
  Navigation,
  Pagination,
  A11y,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Malms from "../../image/LOGO/لوغو_ملمس.png";
import Rnk from "../../image/LOGO/لوغو_رونق.png";
import Sakni from "../../image/LOGO/لوغو_سكني.png";
import Shm from "../../image/LOGO/لوغو_سهم.png";
import Tr from "../../image/LOGO/لوغو_عوالم رقي.png";

const SuccessPartners = (props) => {
  const isMobile = props.isMobile || false;

  const partners = [
    { id: 1, logo: Rnk, name: "رونق", alt: "شعار شركة رونق" },
    { id: 2, logo: Malms, name: "ملمس", alt: "شعار شركة ملمس" },
    { id: 3, logo: Sakni, name: "سكني", alt: "شعار شركة سكني" },
    { id: 4, logo: Shm, name: "سهم", alt: "شعار شركة سهم" },
    { id: 5, logo: Tr, name: "عوالم رقي", alt: "شعار شركة عوالم رقي" },
  ];

  // إعدادات Swiper للشاشات الكبيرة
  const desktopSettings = {
    className: "swiper_container desktop-swiper",
    centeredSlides: true,
    spaceBetween: 5,
    navigation: !isMobile,
    effect: "coverflow",
    grabCursor: true,
    loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    coverflowEffect: {
      rotate: 100,
      stretch: 1,
      depth: 200,
      modifier: 0.5,
      slideShadows: false,
    },
    modules: [EffectCoverflow, Navigation, Pagination, A11y, Autoplay],
  };

  // إعدادات Swiper للشاشات الصغيرة
  const mobileSettings = {
    className: "swiper_container mobile-swiper",
    navigation: false,
    grabCursor: true,
    spaceBetween: 20,
    slidesPerView: "auto",
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
    modules: [Navigation, Pagination, A11y, Autoplay],
  };

  return (
    <Element name="SucPar">
      <section className="SucPar">
        <div className="SucPar-left">
          {/* Swiper للشاشات الكبيرة */}
          {!isMobile && (
            <Swiper {...desktopSettings}>
              {partners.map((partner) => (
                <SwiperSlide key={partner.id}>
                  <div className="partner-slide">
                    <img
                      src={partner.logo}
                      alt={partner.alt}
                      className="partner-logo"
                    />
                    <div className="partner-name">{partner.name}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}

          {/* Swiper للشاشات الصغيرة */}
          {isMobile && (
            <Swiper {...mobileSettings}>
              {partners.map((partner) => (
                <SwiperSlide key={partner.id}>
                  <div className="partner-slide mobile">
                    <img
                      src={partner.logo}
                      alt={partner.alt}
                      className="partner-logo"
                    />
                    <div className="partner-name">{partner.name}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>

        <div className="SucPar-right">
          <p>06</p>
          <span></span>
          <label>شركاء النجاح</label>
        </div>
      </section>
    </Element>
  );
};

export default SuccessPartners;
